import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 py-20 px-6 lg:px-12">
      <div className="max-w-5xl mx-auto bg-white shadow-xl rounded-3xl border border-slate-200 p-10">
        <h1 className="text-5xl font-light mb-6">Intellexa Privacy Policy</h1>
        <p className="text-base text-slate-600 leading-relaxed mb-6">
          At Intellexa, we respect your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, and safeguard the information you provide when you visit our website or contact us.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Information We Collect</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          We collect only the information you voluntarily provide, such as your name, email address, phone number, and message when you submit a contact form. We may also collect non-personal information through cookies and analytics tools to improve site performance.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">How We Use Your Information</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          We use the information you provide to respond to inquiries, deliver requested services, and improve our website. We do not sell or share your personal information with third parties for marketing purposes.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Cookies and Tracking</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          Our website may use cookies or similar technologies to understand how visitors use the site and to enhance the user experience. You can disable cookies in your browser settings, although some features may not function properly.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Data Security</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          We take reasonable steps to protect your information from unauthorized access and disclosure. However, no method of transmission over the internet can be guaranteed to be 100% secure.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Changes to This Policy</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          Intellexa may update this policy from time to time. We encourage you to review this page periodically for the latest information about our privacy practices.
        </p>

        <div className="mt-10">
          <Link to="/" className="text-sm font-medium text-blue-600 hover:underline">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
